import axios from "axios";

// Create Axios instance
const API = axios.create({
  baseURL: "https://ubuntu-backend-745v.onrender.com/api",
  // baseURL: "http://localhost:3000/api",
  
});

// Add interceptor to attach token
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default API;
